import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';

import { APP_SECTION_LIFESTYLE } from 'colours';

import { useTranslation } from 'react-i18next';

import UserProfileContext from 'on_web/context/userProfileContext';

import {
  drinkAlcohol1,
  drinkAlcohol2,
  drinkAlcohol3,
  drinkAlcohol4,
  drinkAlcohol5,
  smoke1,
  smoke2,
  smoke3,
  smoke4,
  smoke5,
} from 'on_web/assets/imageList';

function LifestyleSleepStress(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedSmoke, setSelectedSmoke] = useState(
    context && context.covidLifestyle != null
      ? context.covidLifestyle['smoking_level']
      : undefined
  );
  const [selectedDrink, setSelectedDrink] = useState(
    context && context.covidLifestyle != null
      ? context.covidLifestyle['drinking_level']
      : undefined
  );

  const onClickNext = () => {
    const covid19Lifestyle = context ? context.covidLifestyle : null;
    if (props.onClickNext && covid19Lifestyle) {
      covid19Lifestyle['smoking_level'] = selectedSmoke;
      covid19Lifestyle['drinking_level'] = selectedDrink;
      props.onClickNext(covid19Lifestyle);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  return (
    <div>
      <Header />

      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 2 : 1
          }
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.lifestyleSection.lifestyleSmokeDrink.sectionTitle1'
        )}
        animationImages={[
          {
            image: smoke1,
            height: 116,
          },
          {
            image: smoke2,
            height: 116,
          },
          {
            image: smoke3,
            height: 116,
          },
          {
            image: smoke4,
            height: 116,
          },
          {
            image: smoke5,
            height: 116,
          },
        ]}
        pointSelection={{
          color: APP_SECTION_LIFESTYLE,
          selectedIx: selectedSmoke,
          answers: [
            t('common.answers.answerNone'),
            t('common.answers.answer1to5'),
            t('common.answers.answer5to10'),
            t('common.answers.answer10to20'),
            t('common.answers.answer20+'),
          ],
          textOnBothSides: false,
          tag: 'smoke',
        }}
        onAnswer={ix => setSelectedSmoke(ix)}
      />

      <Question
        sectionTitle={t(
          'onboarding.lifestyleSection.lifestyleSmokeDrink.sectionTitle2'
        )}
        animationImages={[
          {
            image: drinkAlcohol1,
            height: 85,
          },
          {
            image: drinkAlcohol2,
            height: 85,
          },
          {
            image: drinkAlcohol3,
            height: 85,
          },
          {
            image: drinkAlcohol4,
            height: 85,
          },
          {
            image: drinkAlcohol5,
            height: 85,
          },
        ]}
        pointSelection={{
          color: APP_SECTION_LIFESTYLE,
          selectedIx: selectedDrink,
          answers: [
            t('common.answers.answerNone'),
            t('common.answers.answer1to2'),
            t('common.answers.answer3to5'),
            t('common.answers.answer6to8'),
            t('common.answers.answer9plus'),
          ],
          tag: 'drink',
        }}
        onAnswer={ix => setSelectedDrink(ix)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={selectedDrink == null || selectedSmoke == null}
        editMode={context && context.editMode}
      />
    </div>
  );
}

export default LifestyleSleepStress;
